module.exports = __webpack_public_path__ + "static/img/userlogo.44a7f76b.png";